import React from 'react';
import { RichText } from './RichText';
import { stats } from '../../data/landing';
export function StatsBand() {
  return <section aria-label="El megapack en números" className="border-y border-line bg-paper" data-id="element-215" data-mp="2ivlo20eyr6lm">
      <dl className="mx-auto grid max-w-5xl grid-cols-2 gap-y-10 px-5 py-12 md:grid-cols-4 md:py-14" data-id="element-216" data-mp="2du63sakm144a">
        {stats.map(s => <div key={s.label} className="flex flex-col items-center text-center" data-id="element-217" data-mp="28y77m0t1ihtb">
            <dt className="order-2 mt-2 text-xs font-semibold uppercase tracking-[0.14em] text-muted" data-id="element-218" data-mp="24w2ed36i7n77">{s.label}</dt>
            <dd className="order-1 flex h-10 items-center font-serif text-4xl leading-none text-ink md:h-12 md:text-5xl" data-id="element-219" data-mp="201puis1489ux">
              {s.icon ? <s.icon className="h-9 w-9 text-primary md:h-11 md:w-11" strokeWidth={1.5} aria-hidden="true" data-id="element-220" data-mp="1q6ee85a26ul2" /> : <RichText text={s.value ?? ''} data-id="element-221" data-mp="1l60inmpn9d3x" />}
            </dd>
          </div>)}
      </dl>
    </section>;
}